<template>
  <v-card class="full-height">
    <v-card-text class="pa-5">
      <h3 class="title font-weight-regular">Top5</h3>
      <h6 class="subtitle-2 font-weight-light">
        Most viewed content
      </h6>
      <div>
        <div
          v-if="isLoading"
          class="d-flex justify-center align-center"
          style="height:400px"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-list>
          <v-list-item v-for="(item, i) in lists" :key="i" @click="href">
            <v-list-item-title>
              <div class="d-flex align-center py-3">
                <div class="mr-3">
                  <v-avatar>
                    <v-icon
                      :class="item.color"
                      dark
                      v-text="item.icon"
                    ></v-icon>
                  </v-avatar>
                </div>
                <div class="mx-3">
                  <h4 class="font-weight-medium body-2">{{ item.title }}</h4>
                  <span
                    class="text--secondary caption descpart d-block truncate-text"
                    >View {{ item.view }}</span
                  >
                </div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ContentTop5",
  props: ["top5"],
  data: () => ({
    isLoading: false,
    lists: [],
    href() {
      return undefined;
    }
  }),
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  async mounted() {
    this.isLoading = true;
    let iter = 0;

    while (!this.top5) {
      iter++;
      // console.log(iter);
      await this.sleep(100);
      if (iter > 150) break;
    }
    this.lists = this.top5;
    this.lists.forEach((item, idx) => {
      item.color = idx == 0 ? "red" : "blue-grey";
      item.icon = `mdi-numeric-${idx + 1}`;
    });
    this.isLoading = false;
  },
  watch: {
    top5: async function(newVal) {
      this.isLoading = true;
      await this.sleep(1500);
      this.lists = newVal;
      this.lists.forEach((item, idx) => {
        item.color = idx == 0 ? "red" : "blue-grey";
        item.icon = `mdi-numeric-${idx + 1}`;
      });
      this.isLoading = false;
    }
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  .full-height {
    height: 100%;
  }
}
</style>
